import React from "react";
import Image from "next/image";

const Partners = () => {
  const partners = [
    {
      name: "SustainChain",
      logo: "/images/sustainchain_logo.svg",
      alt: "SustainChain logo",
    },
  ];

  return (
    <section className="py-10 px-4 md:px-8 dark:bg-jacarta-800">
      <div className="max-w-6xl mx-auto lg:mb-20 mb-4">
        <div className="text-center mb-16">
          <h3 className="text-md text-accent md:text-lg uppercase tracking-wide mb-2">
            PARTNERS
          </h3>
          <h2 className="text-2xl text-grayish dark:text-[#EDEDED] md:text-3xl font-bold tracking-wide">
            Who We're Working With
          </h2>
        </div>

        {/* Partner logos */}
        <div className="flex flex-wrap justify-center items-center">
          {/* First 3 logos (up to J.B. Dondolo) */}
          <div className="w-1/2 md:w-56 h-16 relative flex items-center justify-center">
            <Image
              src="/images/hanson_robotics_logo.svg"
              alt="Hanson Robotics logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
          <div className="w-1/2 md:w-56 h-16 relative flex items-center justify-center">
            <Image
              src="/images/100_voices_logo.svg"
              alt="SustainChain logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
          <div className="w-1/2 md:w-56 h-16 relative flex items-center justify-center sm:mr-4 mr-0">
            <Image
              src="/images/dondolo_logo.svg"
              alt="J.B. Dondolo logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
          <div className="w-1/2 md:w-20 h-16 relative flex items-center justify-center sm:mr-4 mr-0">
            <Image
              src="/images/aunua_global_logo.svg"
              alt="Aunua logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
          <div className="w-1/2 md:w-36 h-16 relative flex items-center justify-center sm:mr-4 mr-0">
            <Image
              src="/images/BTD_logo.svg"
              alt="Be The Tide logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
          <div className="w-1/2 md:w-52 h-16 relative flex items-center justify-center">
            <Image
              src="/images/sustainchain_logo.svg"
              alt="SustainChain logo"
              fill={true}
              className="object-contain px-4 md:px-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
